import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import { getFaq, storeFaq } from "../../../redux/services/faqService/faq.Services";
import { successToast, errorToast } from "../../../Utils/toast";
const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
      topic: "",
    question: "",
    answer: "",
    keywords: "",
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [greeting, setGreeting] = useState("");
  const [closingQuestion, setClosingQuestion] = useState("");
const fetchFaqs = async () => {
  try {
    setLoading(true);

    const res = await getFaq();
const data = res?.data?.data || res?.data || {};

    setFaqs(data?.faqs || []);
    setGreeting(data?.greeting || "");
    setClosingQuestion(data?.closing_question || "");
  } catch (error) {
    console.log(error);
    errorToast("Failed to load FAQs");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchFaqs();
  }, []);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // 🔹 ADD or UPDATE in local list
  const handleAddOrUpdate = () => {
    if (!form.question.trim() || !form.answer.trim()) {
      return errorToast("Question and Answer required");
    }

    const keywordArray = form.keywords
      .split(",")
      .map((k) => k.trim())
      .filter(Boolean);

    const newFaq = {
       topic: form.topic.trim() || "General",
      question: form.question.trim(),
      answer: form.answer.trim(),
      keywords: keywordArray.length ? keywordArray : [form.question.trim()],
    };

    if (editingIndex !== null) {
      // update
      setFaqs((prev) =>
        prev.map((f, i) => (i === editingIndex ? newFaq : f))
      );
      setEditingIndex(null);
    } else {
      // add
      setFaqs((prev) => [...prev, newFaq]);
    }

    setForm({ question: "", answer: "", keywords: "",topic:"" });
  };

  const handleEdit = (index) => {
    const item = faqs[index];
    setForm({
       topic: item.topic || "",
      question: item.question || "",
      answer: item.answer || "",
      keywords: (item.keywords || []).join(", "),
    });
    setEditingIndex(index);
    setOpenIndex(index);
  };

const handleDelete = (index) => {
  setFaqs((prev) => prev.filter((_, i) => i !== index));
  if (openIndex === index) setOpenIndex(null);
  if (editingIndex === index) {
    setEditingIndex(null);
    setForm({ question: "", answer: "", keywords: "", topic: "" });
  }
};
  // 🔹 SAVE ALL to API
  const handleSaveAll = async () => {
    if (!faqs.length) return errorToast("No FAQ to save");

    try {
      setSaving(true);
      const payload = {
        faqs: faqs.map((f) => ({
           topic: f.topic || "General",
          question: f.question,
          keywords: f.keywords || [f.question],
          answer: f.answer,
        })),
        greeting: greeting || "",
        closing_question: closingQuestion || "",
      };

      const res = await storeFaq(payload);
      successToast(res?.message || "FAQs saved successfully 🚀");
      fetchFaqs(); // refresh from server
    } catch (error) {
      console.log(error);
      errorToast(
        error?.response?.data?.message || "Failed to save FAQs"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between page-header-breadcrumb">
        <div className="title_member">
          <h4>FAQ</h4>
          <nav className="page-breadcrumb">
            <Link to="/">Home</Link>
            <span className="mx-2">/</span>
            <span>FAQ</span>
          </nav>
        </div>

        <button
          className="lead-btn btn-import"
          onClick={handleSaveAll}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save All"}
        </button>
      </div>

      <div className="main_page">
        <div className="card">
          <div className="card-body">

            {/* GREETING + CLOSING */}
            <div className="row mb-3">
              <div className="col-md-6 mb-2">
                <label className="form-label">Greeting</label>
                <input
                  type="text"
                  className="form-control"
                  value={greeting}
                  onChange={(e) => setGreeting(e.target.value)}
                  placeholder="Enter greeting"
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Closing Question</label>
                <input
                  type="text"
                  className="form-control"
                  value={closingQuestion}
                  onChange={(e) => setClosingQuestion(e.target.value)}
                  placeholder="Enter closing question"
                />
              </div>
            </div>

            {/* FORM */}
            <div className="row mb-4">
              <div className="col-md-2 mb-2">
  <input
    type="text"
    className="form-control"
    placeholder="Topic"
    value={form.topic}
    onChange={(e) => setForm({ ...form, topic: e.target.value })}
  />
</div>
              <div className="col-md-5 mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Question"
                  value={form.question}
                  onChange={(e) =>
                    setForm({ ...form, question: e.target.value })
                  }
                />
              </div>
              <div className="col-md-3 mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Keywords (comma separated)"
                  value={form.keywords}
                  onChange={(e) =>
                    setForm({ ...form, keywords: e.target.value })
                  }
                />
              </div>
              <div className="col-md-3 mb-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Answer"
                  value={form.answer}
                  onChange={(e) =>
                    setForm({ ...form, answer: e.target.value })
                  }
                />
              </div>
              <div className="col-md-1 mb-2">
                <button
                  className="lead-btn  w-100"
                  onClick={handleAddOrUpdate}
                >
                  {editingIndex !== null ? <FaEdit/> : <FaPlus />}
                </button>
              </div>
            </div>

            {/* FAQ LIST */}
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
              </div>
            ) : (
              <div className="row">
                {faqs.length === 0 && (
                  <div className="text-center py-4">No FAQ found</div>
                )}
                {faqs.map((faq, index) => (
                  <div className="col-lg-6 col-md-12 mb-3" key={index}>
                    <div className="faq-item">
                      <button
                        type="button"
                        className={`faq-question ${
                          openIndex === index ? "active" : ""
                        }`}
                        onClick={() => handleToggle(index)}
                      >
                        <span>
                          <strong>{index + 1}.</strong> {faq.question}
                        </span>

                        <div className="d-flex align-items-center gap-2">
                          <FaEdit
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(index);
                            }}
                            style={{ cursor: "pointer" }}
                          />
                          <FaTrash
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(index);
                            }}
                            style={{ cursor: "pointer", color: "red" }}
                          />
                          <FaChevronDown
                            className={`faq-icon ${
                              openIndex === index ? "rotate" : ""
                            }`}
                          />
                        </div>
                      </button>

                      {openIndex === index && (
                        <div className="faq-answer">
                          <p>{faq.answer}</p>
                          {faq.keywords?.length > 0 && (
                            <small className="text-muted">
                              Keywords: {faq.keywords.join(", ")}
                            </small>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;